<template>
  <div>
    <!-- В дальнейшем нужно добавить сюда условия для B2B и так далее -->
    <B2cFinanceIncomeExpenses />
</div>
</template>

<script>
  import B2cFinanceIncomeExpenses from '@components/finance/analytic/B2cFinanceIncomeExpenses';

  export default {
    name: "FinanceAnalytic",

    components: {
      B2cFinanceIncomeExpenses,
    }
  };
</script>